module.exports = __webpack_public_path__ + "images/no-image-placeholder-medium-02262d9b.svg";